/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation } from 'react-router';
import { LoaderIcon, UltraVoucherIcon } from '../../utils/svg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addCountryCode, axiosInstance, dateToUnix, formatRupiah, getSecondsLeft, isEmptyData, numberOnly, sendAnalyticsCustomEvent, trackMetaPixelEvent, unixToDate } from '../../utils/helper';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { ListPaymentMethodAll } from '../../utils/constants';
import useToast from '../../components/Toast';
import { setUser } from '../../store/reducers/user';
import { setPayment } from '../../store/reducers/payment';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import useNavigation from '../../hook/useNavigation';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Loader from '../../components/Loader';
import moment from 'moment-timezone';

const UltraValue = () => {
	console.log('UltraValue');
	const location = useLocation();
	const navigate = useNavigation();
	const dispatch = useDispatch();
	const { showToast } = useToast();
	const user = useSelector((store) => store?.user);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingVoucher, setIsLoadingVoucher] = useState(false);
	const [vouchers, setVoucherList] = useState([]);
	const [paymentMethodList, setPaymentMethodList] = useState([]);
	const [isLoadingPaymentMethod, setIsLoadingVoucherPaymentMethod] = useState(false);
	const [isShowBootomSheet, setIsShowBootomSheet] = useState(false);

	const [topupData, setTopupData] = useState({
		telp: null,
		voucher: null,
		paymentMethod: null,
	});

	const topupSchema = Yup.object().shape({
		telp: Yup.string().required('Nomor Telepon diperlukan').min(10, 'Nomor terlalu pendek'),
		voucher: Yup.mixed()
			.test('is-voucher-valid', 'Pilih Nominal', (voucher) => {
				if (typeof voucher === 'object') {
					return true;
				}
				return false;
			})
			.required('Pilih Nominal'),
		paymentMethod: Yup.mixed()
			.test('is-payment-type-valid', 'Pilih Metode Pembayaran', (payment) => {
				if (typeof payment === 'object') {
					return true;
				}
				return false;
			})
			.required('Pilih Metode Pembayaran'),
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: topupData,
		validationSchema: topupSchema,
		onSubmit: async (values, { resetForm }) => {
			sendAnalyticsCustomEvent('topup_ultra_value_pay');
			trackMetaPixelEvent('topup_ultra_value_pay');
			await handlePayment(values, resetForm);
		},
	});

	const { errors, touched, handleSubmit, values, setValues } = formik;
	console.log('touched: ', touched);
	console.log('errors: ', errors);
	console.log('values: ', values);

	const handleGetPaymentList = async () => {
		console.log('handleGetPaymentList');
		try {
			if (!user?.token) return;

			setIsLoadingVoucherPaymentMethod(true);

			const headers = {
				'Content-Type': 'application/json',
			};
			const response = await axiosInstance.post('/ultra-value/list-payment-method', { token: user?.token }, { headers: headers });
			if (response?.data?.status === 'ok') {
				const data = response?.data?.data || [];
				const updatePaymentMethodList = data?.map((d) => {
					const find = ListPaymentMethodAll?.find((type) => type?.code === d?.code);
					if (find) {
						return {
							...d,
							...find,
							fee: d?.fee,
						};
					}
					return {
						...d,
					};
				});
				const defaultPayment = updatePaymentMethodList?.find((d) => d?.code === 'VADIRECTBCA');

				setPaymentMethodList(updatePaymentMethodList);
				console.log('updatePaymentMethodList: ');
				setTopupData((prev) => {
					return {
						...prev,
						paymentMethod: !isEmptyData(defaultPayment) ? defaultPayment : updatePaymentMethodList?.[0],
					};
				});
			}
			setIsLoadingVoucherPaymentMethod(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoadingVoucherPaymentMethod(false);
		}
	};

	const handleGetNominalList = async () => {
		console.log('handleGetNominalList');
		try {
			if (!user?.token) return;

			setIsLoadingVoucher(true);

			const response = await axiosInstance.get('/ultra-value/list-nominal');
			if (response?.data?.status === 'ok') {
				const data = response?.data?.data || [];
				setVoucherList(data);
			}
			setIsLoadingVoucher(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoadingVoucher(false);
		}
	};

	const refreshToken = async () => {
		if (!user?.customerID || !user?.refresh_token) return;
		console.log('refreshToken');
		try {
			const response = await axiosInstance.post(`auth/refresh-token`, {
				refresh_token: user?.refresh_token,
				customer_id: user?.customerID,
			});

			if (response?.status === 200 && response?.data?.status === 'ok') {
				const data = response?.data?.data;
				dispatch(
					setUser({
						token: data?.token,
					}),
				);
			} else {
				showToast('error', 'please relogin', 1000);
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	// useEffect(() => {
	// 	refreshToken();
	// }, []);

	useEffect(() => {
		if (!user) return;
		handleGetNominalList();
		handleGetPaymentList();
	}, [user]);

	const handlePayment = async () => {
		console.log('handlePayment');
		try {
			setIsLoading(true);

			const headers = {
				'Content-Type': 'application/json',
			};
			const body = {
				token: user?.token,
				customer_id: user?.customerID,
				customer_email: user?.email,
				customer_phone: values?.telp,
				customer_name: user?.firstName,
				qty: 1,
				product_code: values?.voucher?.code,
				product_name: values?.voucher?.name,
				product_price: values?.voucher?.price,
				total_amount: values?.voucher?.price + values?.paymentMethod?.fee,
				payment_method: values?.paymentMethod?.code,
			};
			const response = await axiosInstance.post('/ultra-value/payment-top-up', body, { headers: headers });
			if (response?.data?.status) {
        const data = response?.data?.data;
        const unixtime = typeof data?.expired_at === 'string' ? dateToUnix(data?.expired_at) : data?.expired_at;

				dispatch(
					setPayment({
            ...data,
						session_token: response?.data?.session_token || null,
            date: moment().tz("Asia/Jakarta").format("YYYY-MM-DD HH:mm:ss"),
            expired_date: unixToDate(unixtime),
            timeLeft: getSecondsLeft(unixtime),
						status: null,
					}),
				);

				navigate.push('/payment');
			} else {
				showToast('error', response?.data?.message || '', 1000);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	const BottomSheetContent = () => {
		if (!isShowBootomSheet) return null;
		return (
			<BottomSheet open={isShowBootomSheet} onDismiss={setIsShowBootomSheet}>
				<div className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl translate-y-0 relative`}>
					<div className='flex justify-center py-4 text-base text-gray-900 font-semibold'>Pilih Metode Pembayaran</div>
					{paymentMethodList?.map((payment, index) => {
						return (
							<div
								id={payment?.id}
								key={`payment_${index}`}
								className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center min-h-14`}
								onClick={() => {
									sendAnalyticsCustomEvent(`topup_ultra_value_select_payment_method_${payment?.company}`);
									trackMetaPixelEvent(`topup_ultra_value_select_payment_method_${payment?.company}`);
									setValues((prev) => {
										return {
											...prev,
											paymentMethod: payment,
										};
									});
								}}>
								<div className='flex items-center'>
									<img alt={payment?.alt ?? ''} src={payment?.image_url} className={payment?.image_size || 'w-9 h-auto'} />
									<div className='pl-2'>
										<div className={`text-xs capitalize font-semibold text-gray-900`}>{`${payment?.name}`}</div>
									</div>
								</div>
								<div className='flex flex-row items-center'>
									<div className='pl-2'>
										<input
											id='payment'
											type='radio'
											name='payment'
											value={payment?.code}
											checked={values?.paymentMethod?.code === payment?.code}
											onChange={() => null}
											className={`${values?.paymentMethod?.code === payment?.code ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white focus:!bg-transparent`}
										/>
									</div>
								</div>
							</div>
						);
					})}
					<button
						id='payment_methods_choose'
						className='mt-10 w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center'
						onClick={() => {
							setIsShowBootomSheet(false);
						}}>
						Pilih Pembayaran
					</button>
				</div>
			</BottomSheet>
		);
	};

	const FooterContent = () => {
		if (isShowBootomSheet) return null;
		return (
			<div className={`bg-white p-4 w-full bottom-0 left-0 z-40 shadow-custom absolute`}>
				<button id='ultra_voucher_pay' type='button' className='bg-[var(--rose-violet)] text-white mt-2 w-full flex justify-center font-normal text-sm p-3 items-center border-0' onClick={() => handleSubmit()}>
					<div>Payment</div>
				</button>
			</div>
		);
	};

	return (
		<div className='flex flex-col min-h-screen relative bg-white'>
			{isLoading && <Loader overlay />}
			<div className={`p-4 flex flex-row items-center border-b-1 border-solid border-gray-200 sticky top-0 ${!isShowBootomSheet && 'z-40'} min-w-full min-h-10`}>
				<ArrowLeftIcon className={`h-8 w-8 text-gray-900 p-1.5`} onClick={() => navigate.back()} />
				<div className={`text-gray-700 font-semibold pl-2 text-base`}>Top Up Ultra Value</div>
			</div>
			<div className='flex flex-col p-4'>
				<div className='flex justify-between'>
					<div className='flex items-center flex-row'>
						<UltraVoucherIcon />
						<div className='pl-2 text-gray-700 text-xs'>
							<div>Ultra Value</div>
							<div className='font-semibold'>{formatRupiah(location?.state?.balance ?? 0)}</div>
						</div>
					</div>
					<div className='w-[65%]'>
						<input
							className='!mb-0 !py-2.5 !px-4 !text-xs placeholder:text-xs placeholder:text-gray-400 !border-1 !border-solid !border-gray-300 !h-auto !bg-white w-full'
							type='text'
							value={values?.telp}
							placeholder='Masukan Nomer Handphone'
							onChange={(e) => {
								const number = numberOnly(e?.target?.value);
								console.log('number: ', number);
								sendAnalyticsCustomEvent('topup_ultra_value_input_phone_number');
								trackMetaPixelEvent('topup_ultra_value_input_phone_number');
								setValues((prev) => {
									return {
										...prev,
										telp: addCountryCode(number),
									};
								});
							}}
						/>
						<span className={`text-xs text-red-500 ${touched?.telp && errors?.telp}`}>{errors?.telp}</span>
					</div>
				</div>
				<div className='pt-3 pb-4 border-b-1 border-solid border-gray-300'>
					<div className='text-sm font-semibold text-gray-700 hidden'>Nominal</div>
					<div className='bg-gray-100 py-8 text-center rounded-lg border-1 border-solid border-gray-300'>{formatRupiah(values?.voucher?.nominal ?? 0)}</div>
					{isLoadingVoucher ? (
						<div className='flex justify-center items-center w-full h-full'>
							<LoaderIcon />
						</div>
					) : (
						<div className='grid grid-cols-3 gap-3 mt-5'>
							{vouchers?.map((voucher, index) => {
								return (
									<button
										key={index}
										className={`rounded-md border-1 border-solid py-2.5 text-xs font-semibold ${
											voucher?.code === values?.voucher?.code ? '!border-[var(--rose-violet)] text-[var(--rose-violet)]' : 'border-gray-300 text-gray-700'
										}`}
										onClick={() => {
											sendAnalyticsCustomEvent(`topup_ultra_value_select_nominal_${voucher?.nominal}`);
											trackMetaPixelEvent(`topup_ultra_value_select_nominal_${voucher?.nominal}`);
											setValues((prev) => {
												return {
													...prev,
													voucher: voucher,
												};
											});
										}}>
										{formatRupiah(voucher?.nominal, { showCurrency: false })}
									</button>
								);
							})}
						</div>
					)}
					<span className={`text-xs text-red-500 ${touched?.voucher && errors?.voucher}`}>{errors?.voucher}</span>
				</div>
				<div className='pt-3'>
					<div className='text-sm font-semibold text-gray-700'>Payment Method</div>
					<div id='topup_ultra_value_payment_methods' className={`mt-2 border-solid border-1 border-gray-300 rounded-lg px-4 py-2.5 flex justify-between items-center min-h-14`}>
						{isLoadingPaymentMethod ? (
							<div className='flex justify-center items-center w-full h-full'>
								<LoaderIcon />
							</div>
						) : (
							<div className='flex justify-between w-full' onClick={() => setIsShowBootomSheet(true)}>
								<div className='flex items-center'>
									<img alt={values?.paymentMethod?.alt ?? ''} src={values?.paymentMethod?.image_url} className={values?.paymentMethod?.image_size ?? 'w-9 h-auto'} />
									<div className='pl-2'>
										<div className='text-gray-700 text-xs font-thin'>{values?.paymentMethod?.name ?? ''}</div>
									</div>
								</div>
								<ChevronRightIcon className='h-4 w-4 text-gray-800' strokeWidth={3} />
							</div>
						)}
					</div>
				</div>
			</div>
			<FooterContent />
			<BottomSheetContent />
		</div>
	);
};

export default UltraValue;
